/**
 * Add event listener for search result sort.
 */
document.getElementById('sort_by').addEventListener('change', function() {
  const url = new URL(location);
  url.searchParams.set('sort_by', this.value);
  location = url;
});


/**
 * Recent Searches.
 */
(function() {
  const LOCAL_STORAGE_NAME = 'p4_recent_search';
  const url = new URL(location);
  const currentSearchQuery = url.searchParams.get('q');

  // Get recent searches with current query removed and reduced to 10 queries.
  const cleanedSearch =
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_NAME))?.filter(search => search.q !== currentSearchQuery).slice(0, 10) ??
    [];

  // Show recent searches, if any.
  if (cleanedSearch.length) {
    const html = cleanedSearch.reduce((accum, search) => {
      return accum + `<a href="${search.href}" class="block-hover">${search.q}</a>`;
    }, '');
    document.getElementById('js-recent-search').insertAdjacentHTML('beforeend', html);
    document.getElementById('js-recent-search--placeholder').remove();
  } else {
    document.getElementById('js-recent-search--placeholder').hidden = false;
  };

  // Add current search query to recent searches.
  localStorage.setItem(LOCAL_STORAGE_NAME, JSON.stringify([
    {
      q: currentSearchQuery,
      href: url.href,
    },
    ...cleanedSearch,
  ]));
})();
